export enum ViewerTypeEnum {
  OPEN = 'open',
  PROPS = 'props',
  NAME = 'infoName',
  EMAIL = 'infoEmail',
  ADDRESS = 'infoAddress',
  PHONE = 'infoPhone',
  KANO = 'kano',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  HEADER = 'header',
  IMAGE = 'image',
  CHECKBOX_MATRIX = 'checkboxMatrix',
  RADIO_MATRIX = 'radioMatrix',
  HONEYPOT = 'honeyPot',
  PRICERANGE = 'priceRange',
  IMAGEUPLOAD = 'imageUpload',
  AUDIORECORDER = 'audioRecorder',
}
